import React from 'react';
import { useStyles } from './RangeValueEditor.styles';
import { HubspotFieldEditorProps } from '../../../editors/types';

interface RangeValueEditorProps extends HubspotFieldEditorProps {
  EditorComponent: React.FC<HubspotFieldEditorProps>;
}

export const RangeValueEditor: React.FC<RangeValueEditorProps> = (props) => {
  const { value = [], onChange, EditorComponent } = props;
  const [start = '', end = ''] = value;
  const classes = useStyles();

  const handleStartChange = (newStart: any) => {
    onChange([newStart, end]);
  }

  const handleEndChange = (newEnd: any) => {
    onChange([start, newEnd]);
  }

  return (
    <div className={classes.rangeValueEditor}>
      <EditorComponent value={start} onChange={handleStartChange} />
      <EditorComponent value={end} onChange={handleEndChange} />
    </div>
  );
};
